// 高德地图
export const AMAP_KEY: string = 'e9c4e1537725c67ae982d59e02c6eca4'
export const AMAP_VERSION: string = '1.4.15'
// 售后专项活动名称
export const AS_ACTIVITY_NAME: string = '专项服务'
export const AS_ACTIVITY_TIP: string = '网点休息或预约已满时段不会显示'
// 灰度
export const GRAY_ENABLED = false // 灰度开关
export const GRAY_FLAG = 'group_v' // 灰度组标识
export const GRAY_TIMEOUT_SEC = 3 // 灰度接口超时时间
export const GRAY_SESSION_KEY = '__GRAY_SESSION_KEY__'
// 客服热线
export const CUSTOMER_SERVICE_TEL = '4007836688'